import 'swiper/css'
import 'swiper/css/pagination'
import { AppProviders } from 'pages/_app'
import CartProvider from 'apps/Diner/contexts/Cart/CartProvider'
import { ApolloProvider } from '@apollo/client'
import client from 'apps/Diner/apollo/client'
import DynamicThemeProvider from 'apps/Diner/contexts/DynamicTheme/DynamicThemeProvider'
import DinerLocationProvider from 'apps/Diner/contexts/DinerLocation/DinerLocationProvider'
import UserSessionProvider from 'contexts/UserSession/UserSessionProvider'
import TrackingProvider from 'contexts/Tracking/TrackingProvider'
import { SnackbarProvider } from 'notistack'

export const DinerProviders = ({
  children,
  shouldCreateGuestSession = true
}: {
  children: JSX.Element
  shouldCreateGuestSession?: boolean
}): JSX.Element => {
  return (
    <AppProviders>
      <SnackbarProvider hideIconVariant maxSnack={3}>
        <DinerLocationProvider>
          <TrackingProvider>
            <UserSessionProvider
              shouldCreateGuestSession={shouldCreateGuestSession}
            >
              <CartProvider>
                <DynamicThemeProvider>{children}</DynamicThemeProvider>
              </CartProvider>
            </UserSessionProvider>
          </TrackingProvider>
        </DinerLocationProvider>
      </SnackbarProvider>
    </AppProviders>
  )
}

const DinerContainer = ({
  children
}: {
  children: JSX.Element
}): JSX.Element => {
  return (
    <ApolloProvider client={client}>
      <DinerProviders>{children}</DinerProviders>
    </ApolloProvider>
  )
}

export default DinerContainer
